import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = (size, wrapperWidth) => makeStyles((theme) => {
    console.log('size', size);
    if (wrapperWidth < 700) {
        return {
            root: {
                position: 'absolute',
                top: wrapperWidth / 1.3333 - 30
            }
        }
    }
    return {
        root: {
            position: 'absolute',
            top: 490,
            [theme.breakpoints.up('xs')]: {
                top: size === 'mxx' ? 220 : 280,
            },
            [theme.breakpoints.up('sm')]: {
                top: size === 'xl' ? 420 : size === 'l' ? 280 : size === 'mxxx' ? 410 : 490,
            },
        }
    }
});
const useGalleryStyles = makeStyles((theme) => {
    return {
        root: {
            position: 'absolute',
            top: 170,
            [theme.breakpoints.up('xs')]: {
                top: 100,
            },
            [theme.breakpoints.up('sm')]: {
                top: 170,
            },
            '@media print' : {
                display: 'none !important'
            }
        }
    }
});
export default function Flex(props) {
    const classes = useStyles(props.size, props.wrapperWidth)();
    const galleryClasses = useGalleryStyles();
    let useClasses = props.isGallery ? galleryClasses : classes;

    const targetW = props.size === 'xxxl' ? 700 : props.wrapperWidth;
    const amount = Math.floor(targetW / (props.isMobile ? 16 : 22));

    console.log('amount', amount)
    const children = props.children.slice(0, amount);
    return (
        <div className={useClasses.root}>{children}</div>
    );
}
